import { HotelRoom } from "src/store/slices/hotels/Hotels";
import { buildTrie, PathTree } from "src/utility/tree";

const MAX_FACILITIES = 4;

const HOTEL_PROPS = {
  hotelName:           { path: ["hotelName"],    default: "" },
  address:             { path: ["address"] },
  image:               { path: ["image"] },
  currency:            { path: ["currency"],     default: "" },
  originalCurrency:    { path: ["originalCurrency"], default: "" },
  bestUnit: {
    path: ["rooms"],
    default: null,
    transform: (rooms: HotelRoom[]) =>
      rooms?.length > 0
        ? rooms.reduce((best, unit) => (unit.totalFare < best.totalFare ? unit : best))
        : null,
  },
  totalFare: {
    path: [],
    transform: (hotel: any) => {
      const best = hotel?.rooms?.length > 0
        ? hotel.rooms.reduce((b: HotelRoom, u: HotelRoom) => (u.totalFare < b.totalFare ? u : b))
        : null;
      return best?.totalFare ?? hotel?.minPrice ?? null;
    },
  },
  totalOriginalFare: {
    path: [],
    transform: (hotel: any) => {
      const best = hotel?.rooms?.length > 0
        ? hotel.rooms.reduce((b: HotelRoom, u: HotelRoom) => (u.totalFare < b.totalFare ? u : b))
        : null;
      return best?.totalOriginalFare ?? null;
    },
  },
  starCount: {
    path: ["hotelRating"],
    default: 0,
    transform: (rating: number | null) => (rating ? Math.round(rating) : 0),
  },
  ratingLabel: {
    path: ["hotelRating"],
    default: "",
    transform: (rating: number | null) => {
      const count = rating ? Math.round(rating) : 0;
      if (count >= 5) return `${count}-STAR LUXURY`;
      if (count > 0) return `${count}-STAR`;
      return "";
    },
  },
  displayedFacilities: {
    path: ["facilities"],
    default: [],
    transform: (facilities: string[]) => facilities?.slice(0, MAX_FACILITIES) ?? [],
  },
  hasFacilities: {
    path: ["facilities"],
    default: false,
    transform: (facilities: string[]) => (facilities?.length ?? 0) > 0,
  },
} satisfies PathTree;

const DERIVED_HOTEL_TREE = buildTrie(HOTEL_PROPS);

export { DERIVED_HOTEL_TREE, MAX_FACILITIES };
